import decode from "jwt-decode";
import { axiosAuthPlanos, axiosDefault, axiosBearerSite, axiosRenewToken } from "../api";

const isPayloadExpired = (payloadExp) => {
  return new Date().getTime() > payloadExp * 1000
}

const authService = {
  signIn: async (username, password) => {
    const res = await axiosDefault.get(`site/sys/auth/signIn`, {
      auth: { username, password }
    });
    const user = res.data;
    sessionStorage[process.env.REACT_APP_JWT_TOKEN_PESSOA] = user.accessToken.token;
    return user;
  },
  sendEmailConference: async input => {
    const res = await axiosBearerSite.post("site/com.levty/levtyFacade/registerEnterprise", {
      name: input.personName,
      email: input.personEmail,
      phoneNumber: input.personPhone,
      contactReason: "commercial",
      enterpriseName: input.enterpriseLegalName,
      enterpriseCnpj: input.enterpriseCnpj
    });
    return res.data;
  },
  registerEnterprise: async input => {
    console.log(input)
    const res = await axiosBearerSite.post("site/com.levty/levtyFacade/registerEnterprise", {
      name: input.personName,
      email: input.personEmail,
      phoneNumber: input.personPhone,
      password: input.personPassword,
      message: "Cadastro pelo site da LEVTY",
      emailToken: input.emailToken,
      contactReason: "commercial",
      enterpriseName: input.enterpriseLegalName,
      enterpriseCnpj: input.enterpriseCnpj,
      languageSite: "Português"
    });
    return res.data;
  },
  getAuthenticatedUser: async () => {
    try {
      const res = await axiosAuthPlanos.post(`site/com.levty/levtyFacade/getAuthenticatedUser`, {});
      const user = res.data;
      return user;
    } catch (error) {
      console.log(error);
      // logout();
    }
  },
  renewToken: async (token) => {
    try {
      const req = axiosRenewToken;
      req.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      const res = await req.get();
      return res.data;
    } catch (error) {
      console.log(error);
    }
  },
  getAuthenticatedUserPayload: () => {
    try {
      const payload = decode(sessionStorage[process.env.REACT_APP_JWT_TOKEN_PESSOA]);
      if (isPayloadExpired(payload.exp)) {
        this.logout("Sua sessão expirou");
        window.location.reload();
      }
      return payload;
    } catch (error) {
      return null
    }
  },
  isAuthenticated: () => {
    try {
      const payload = decode(sessionStorage[process.env.REACT_APP_JWT_TOKEN_PESSOA]);
      if (isPayloadExpired(payload.exp)) {
        this.logout("Sua sessão expirou");
        window.location.reload();
      }
      return payload.active;
    } catch (error) {
      return false
    }
  },
  logout: messageLogout => {
    sessionStorage.removeItem(process.env.REACT_APP_JWT_TOKEN_PESSOA);
    if (!!messageLogout)
      sessionStorage.messageLogout = messageLogout;

    window.location.replace("/");
  }
}

export default authService;